export class Category {
    constructor(
        public id = 0,
        public name = '',
    ) {
    }
}